import moment from 'moment';
import type { MonthDescriptor } from './types';

function getAlternatingExpandedKeys(months: MonthDescriptor[]): string[] {
  return months.filter((_, index) => index % 2 === 1).map(month => month.key);
}

export function getDefaultExpandedMonths(months: MonthDescriptor[]): string[] {
  if (months.length === 0) {
    return [];
  }

  const today = moment().startOf('day');
  const rangeStart = moment(months[0].key, 'YYYY-MM').startOf('month');
  const rangeEnd = moment(months[months.length - 1].key, 'YYYY-MM').endOf(
    'month'
  );

  const todayInRange =
    today.isSameOrAfter(rangeStart, 'day') &&
    today.isSameOrBefore(rangeEnd, 'day');

  if (!todayInRange) {
    return getAlternatingExpandedKeys(months);
  }

  const todayMonthKey = today.format('YYYY-MM');
  const todayMonthIndex = months.findIndex(
    month => month.key === todayMonthKey
  );

  if (todayMonthIndex === -1) {
    return getAlternatingExpandedKeys(months);
  }

  const isLastDayOfMonth = today.date() === today.daysInMonth();

  if (isLastDayOfMonth && todayMonthIndex < months.length - 1) {
    return [months[todayMonthIndex + 1].key];
  }

  return [todayMonthKey];
}
